import { Auth, Config } from 'olympe';
import { addLeadingZeroes } from '../shared/_filters';

export const getSkuData = async (nextCursor, pageSize, filters) => {
    const rootUrl = Config.getParameter('sku_post_path');
    const proxyUrl = Config.getParameter('http_proxy_path');
    const access_token = sessionStorage.getItem("ms_auth_token");
    console.log("::: getSkuData: access_token ::::", access_token)
    let startIndex = nextCursor ? nextCursor : 0;
    let endIndex = startIndex + pageSize - 1;
    const userRole = JSON.parse(localStorage.getItem('plants'));
    const userPlants = userRole.roles['roles-details']['company-codes'].plants.map(item => item.plantID);

    let body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
        },
        opperation: 'POST',
        payload: {
            offset: startIndex.toString(),
            limit: endIndex.toString(),
            plants: userPlants
        },
    };

    if (filters) {
        if (filters.markets) body.payload.markets = filters.markets;
        if (filters.plants) body.payload.plants = filters.plants.map((plant) => plant.split(' - ')[0]);
        if (filters.producingCompanyCode) body.payload.producingCompanyCodes = filters.producingCompanyCode;
        if (filters.sellingCompanyCode) body.payload.sellingCompanyCodes = filters.sellingCompanyCode;
        if (filters.business) body.payload.businesses = filters.business;
        if (filters.nestecProductCategory) body.payload.nestecProductCategories = filters.nestecProductCategory.map((npc) => {
            if (npc.split(' - ')[0].length === 1) return '0' + npc.split(' - ')[0];
            else return npc.split(' - ')[0];
        });
        if (filters.product) body.payload.products = filters.product.map((product) => addLeadingZeroes(product.split(' - ')[0]));
        if (filters.marketCritical) body.payload.marketCritical = filters.marketCritical;
        if (filters.marketShortlist) body.payload.marketShortlist = filters.marketShortlist;
        if (filters.exportedProduct) body.payload.exportedProduct = filters.exportedProduct;
        if (filters.modifiedBy) body.payload.modifiedBy = filters.modifiedBy.map(user => user.split('(').pop().split(')')[0]);
        if (filters.nnsStatus) body.payload.nnsStatuses = filters.nnsStatus;
        if (filters.pl3Category) body.payload.pl3Categories = filters.pl3Category;
        if (filters.pl2Business) body.payload.pl2Businesses = filters.pl2Business;
        if (filters.rangeBrand) body.payload.rangeBrands = filters.rangeBrand;
    }


    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        if (!request.ok) {
            throw new Error(`Error ${request.status}`);
        }

        // Fix for the 204 response from the Delete, we check first if we received something.
        let result = await request.json();
        if (result.products !== null && (result.products.length - 1) === (endIndex - startIndex)) {
            result.nextCursor = endIndex;
        } else {
            result.nextCursor = null;
        }
        return result;
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};

// TODO : This whole service needs to be refactired.
// Applied a shitty quick fix, for when only inserting new records.
export const updateSku = async (data, operation, dataPut, dataInsert) => {

    const rootUrl = Config.getParameter('sku_put_delete_path');
    const proxyUrl = Config.getParameter('http_proxy_path');
    const access_token = sessionStorage.getItem("ms_auth_token");
    if (operation === 'DELETE') {
        const bodyDelete = prepareBody(rootUrl, data, operation);

        console.log('body del', bodyDelete);

        try {
            const request = await fetch(proxyUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${access_token}`,
                },
                body: JSON.stringify(bodyDelete),
            });
            if (!request.ok) {
                throw new Error(`Error ${request.status}`);
            }

            // Fix for the 204 response from the Delete, we check first if we received something.
            let result = await request.text();
            return result.length ? JSON.parse(result) : { error: false };
        } catch (error) {
            return {
                error: true,
                message: error.message,
            };
        }
    } else {

        const bodyPut = prepareBody(rootUrl, dataPut, operation);
        const bodyInsert = prepareBody(rootUrl, dataInsert, 'POST');

        try {

            let requestInsert, requestPut = null;
            if (bodyPut.payload.length >= 1) {
                requestPut = await fetch(proxyUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${access_token}`,
                    },
                    body: JSON.stringify(bodyPut),
                });
            }

            if (bodyInsert.payload.length >= 1) {
                requestInsert = await fetch(proxyUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${access_token}`
                        
                    },
                    body: JSON.stringify(bodyInsert),
                });
            }

            if ((requestPut && !requestPut.ok) || (requestInsert && !requestInsert.ok)) {
                throw new Error(`Error when calling the Mulesoft API`);
            }

            return { error: false };
        } catch (error) {
            return {
                error: true,
                message: error.message,
            };
        }
    }
};

const prepareBody = (rootUrl, data, operation) => {
    const access_token = sessionStorage.getItem("ms_auth_token");
    let body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        opperation: operation === 'DELETE' ? 'DELETE' : (operation === 'POST' ? 'POST' : 'PUT'),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`
        },
        payload: []
    };
    data.map(record => {

        // Quick fix in case the user has no selected anything
        if (!record.modifiedBy.userId && !record.marketCritical && !record.marketShortlist && !record.exportedProduct)
            // eslint-disable-next-line array-callback-return
            return;

        // eslint-disable-next-line consistent-return
        return body.payload.push({
            plant: record.plantId,
            producingCompanyCode: record.producingCompanyCode ? record.producingCompanyCode : '',
            sellingCompanyCode: record.sellingCompanyCode ? record.sellingCompanyCode : '',
            productId: record.product ? record.product : '',
            modifiedBy: {
                userId: localStorage.getItem('userName'),
                fullName: localStorage.getItem('userFullName'),
                email: localStorage.getItem('userEmail'),
            },
            nnsStatus: (operation === 'PUT' || operation === 'POST') ? record.nnsStatus : '',
            marketCritical: (operation === 'PUT' || operation === 'POST') ? record.marketCritical : '',
            marketShortlist: (operation === 'PUT' || operation === 'POST') ? record.marketShortlist : '',
            exportedProduct: (operation === 'PUT' || operation === 'POST') ? record.exportedProduct : '',
            lastModified: (operation === 'PUT' || operation === 'POST') ? new Date().toISOString() : ''
        });
    });
    return body;
};


export const GetLookupDataSku = async (
    search,
    filterType,
    filtersArrays
) => {

    const rootUrl = Config.getParameter('sku_lookup_path');
    const proxyUrl = Config.getParameter('http_proxy_path');

    const userRole = JSON.parse(localStorage.getItem('plants'));
    const userPlants = userRole.roles['roles-details']['company-codes'].plants.map((item) => item.plantID);
    const access_token = sessionStorage.getItem("ms_auth_token");
    console.log("::: access_token :GetLookupDataSku ::::", access_token)
    const body = {
        destination: rootUrl,
        token: Auth.getUserToken().nonce,
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${access_token}`,
        },
        opperation: 'POST',
        payload: {
            entity: filterType,
            searchValue: search,
            plants: filtersArrays.plantsSelectedArray[0] === undefined ? userPlants : filtersArrays.plantsSelectedArray,
            producingCompanyCodes: filterType === 'producingCompanyCode' ? [] : filtersArrays.producingCompanySelectedArray,
            sellingCompanyCodes: filterType === 'sellingCompanyCode' ? [] : filtersArrays.sellingCompanySelectedArray,
            businesses: filterType === 'business' ? [] : filtersArrays.businessSelectedArray,
            nestecProductCategories: filterType === 'nestecProductCategory' ? [] : filtersArrays.nestecProductCategorySelectedArray,
            products: filterType === 'product' ? [] : filtersArrays.productSelectedArray.map(product => addLeadingZeroes(product.split(' - ')[0])),
            marketCritical: filterType === 'marketCritical' ? [] : (typeof filtersArrays.marketCriticalSelectedArray === 'boolean') ? [JSON.stringify(filtersArrays.marketCriticalSelectedArray)] : [],
            marketShortlist: filterType === 'marketShortlist' ? [] : (typeof filtersArrays.marketShortlistSelectedArray === 'boolean') ? [JSON.stringify(filtersArrays.marketShortlistSelectedArray)] : [],
            exportedProduct: filterType === 'exportedProduct' ? [] : (typeof filtersArrays.exportedProductSelectedArray === 'boolean') ? [JSON.stringify(filtersArrays.exportedProductSelectedArray)] : [],
            modifiedBy: filterType === 'modifiedBy' ? [] : filtersArrays.modifiedBySelectedArray,
            nnsStatuses: filterType === 'nnsStatus' ? [] : filtersArrays.nnsStatusSelectedArray,
            pl3Categories: filterType === 'pl3Category' ? [] : filtersArrays.pl3CategorySelectedArray,
            pl2Businesses: filterType === 'pl2Business' ? [] : filtersArrays.pl2BusinessSelectedArray,
            rangeBrands: filterType === 'rangeBrand' ? [] : filtersArrays.rangeBrandSelectedArray,
        },
    };


    try {
        const request = await fetch(proxyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });

        if (!request.ok) {
            throw new Error(`Error ${request.status}`);
        }
        const result = await request.json();
        return result;
    } catch (error) {
        return {
            error: true,
            message: error.message,
        };
    }
};
